import { useEffect, useState, useCallback } from 'react';

const RHENTI_SCRIPT_URL = 'https://rhenti-widgets.azureedge.net/rhenti-widgets.js';
const RHENTI_SCRIPT_ID = 'rhenti-widgets-script';

// Centralized Rhenti configuration - UPDATE THIS VALUE
export const RHENTI_WHITELABEL_ID = '6931f6f3cd23c75167f8dd66';

/**
 * Custom hook to load Rhenti widgets script dynamically
 * Only loads once even if used in multiple components
 * Returns functions to trigger widget modals with native buttons
 */
export const useRhentiWidget = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check if script is already loaded
    const existingScript = document.getElementById(RHENTI_SCRIPT_ID);
    
    if (existingScript) {
      setIsLoaded(true);
      return;
    }

    // Create and load script
    const script = document.createElement('script');
    script.id = RHENTI_SCRIPT_ID;
    script.src = RHENTI_SCRIPT_URL;
    script.async = true;

    script.onload = () => {
      setIsLoaded(true);
    };

    script.onerror = () => {
      setError(new Error('Failed to load Rhenti widgets script'));
    };

    document.body.appendChild(script);

    // Cleanup function - don't remove script as other components may use it
    return () => {
      // Script persists for other components
    };
  }, []);

  /**
   * Trigger the Rhenti widget modal
   * @param {string} widgetTagName - 'rhenti-book' or 'rhenti-contact'
   */
  const openWidget = useCallback((widgetTagName) => {
    const rhentiWidget = document.querySelector(widgetTagName);
    if (!rhentiWidget) {
      console.error(`Rhenti widget <${widgetTagName}> not found.`);
      return;
    }
    // Trigger modal on custom element
    rhentiWidget.showModal = false;
    setTimeout(() => {
      rhentiWidget.showModal = true;
    }, 50);
  }, []);

  const openContactForm = useCallback(() => openWidget('rhenti-contact'), [openWidget]);
  const openBookingForm = useCallback(() => openWidget('rhenti-book'), [openWidget]);

  return { isLoaded, error, openContactForm, openBookingForm };
};

export default useRhentiWidget;
